import { z } from 'zod';

export const projectAssetSearchSchema = z.object({
  q: z.string().trim().min(1).optional().catch(undefined),
});
